import React, { useEffect, useState } from 'react';
// import styles from '../rates-page/RatesPage.module.scss';
import styles from '../../views/transfer-page/TransferPage.module.scss';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { transcationActions, beneficiaryActions } from '../../stores/_actions';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import { RecentTranscation } from '../common/recent-transcation/Recent-Transcation';
import { Transcation } from '../common/transcation/Transcation';
import { Button } from 'semantic-ui-react';
import { NoRecord } from '../common/norecord/norecord';

const TranscationRef = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const jsonData = localStorage.getItem('userProfile');
  const [transStatus, setTransStatus] = useState(null);

  let userProfile;
  useSelector((state) => {
    userProfile = state.getCustDetails?.data;
  });
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      ReferenceNo: location.state?.refno,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    Langcode: '0001',
  };
  const [transcationData, setData] = useState();

  const listPayload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      Refno: '',
      FromDate: '01/Jan/1950',
      ToDate: '01/Jan/2099',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };
  const benePayload = {
    Id: null,
    Message: null,
    CustomerCode: profile?.CustomerCode,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  const params = window.location.search;
  useEffect(() => {
    if (params) {
      payload.Data['ReferenceNo'] = params.substring(params.indexOf('=') + 1, params.indexOf('&'));
      setTransStatus(params?.substring(params?.lastIndexOf('=') + 1));
      history.push({
        pathname: '/transcation-view',
        state: { refno: payload.Data['ReferenceNo'], status: params?.substring(params?.lastIndexOf('=') + 1) },
      });
      // history.replace('/transcation-view');
    }
    setTimeout(() => {
      dispatch(transcationActions.getTransactionSearchByRefno(payload));
      dispatch(transcationActions.transcationList(listPayload));
      dispatch(beneficiaryActions.beneficiaryClient(benePayload));
    }, 10);
    //  setData((transcationData) => ({...transcationData, transcationListData}))
  }, []);

  let transcationListData;
  let status;
  let loading;
  useSelector((state) => {
    transcationListData = state.getTransactionRef?.data;
    loading = state.getTransactionRef?.loading;
    status = state.getTransactionRef?.getTranscation;
    setTimeout(() => {
      setData((transcationData) => ({ ...transcationData, transcationListData }));
    }, 100);
  });

  const print = () => {
    window.print();
  };

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              {loading ? (
                <div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '20px' }}>Loading...</div>
              ) : transcationListData ? (
                <Transcation transcationListData={transcationListData} qPayMsg={transStatus || location.state?.status} styles={styles} />
              ) : (
                <NoRecord status={status} />
              )}
              {/* {} */}
              <div className={styles.pageLeft__buttonCenter}>
                <Button onClick={print}>print</Button>
                <Link to={'/transfer'}>make another transaction</Link>
              </div>
            </div>
            <RecentTranscation />
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
};

export { TranscationRef };
